import FaqBlock from '../../components/FaqBlock';
import FleetHero from '../../components/fleet/FleetHero';
import { ContentTextBox } from '../../components/rentAndShare/ContentTextBox';
import { TwoFlexibleComponentBox } from '../../components/rentAndShare/TwoFlexibleComponentBox';
import Snippet from '../../components/Snippet';
import KIAImage from '../../components/ui/image/KIAImage';

const RentAndShareLanding = () => {
  return (
    <main>
      <FleetHero
        title="Kia Drive"
        subtitle="Hyr & Dela"
        image="https://kia-afonso-storage.b-cdn.net/Kia-Hyr-och-dela-bilar.jpg"
        mobileImage="https://kia-afonso-storage.b-cdn.net/Kia-Hyr-och-dela-bilar-mobile-2.jpg"
      />
      <div className="w-full max-w-screen-kia mx-auto">
        <TwoFlexibleComponentBox
          firstComponent={
            <ContentTextBox className="max-w-[650px]" title="Kontakta oss">
              <div className="flex gap-4 flex-col">
                <p>
                  Är ditt företag intresserade av Kia Drive eller är ni redan
                  kund och har frågor kring avtal och upplägg? Mejla oss på{' '}
                  <a href="mailto:mobilitet@kia.se">mobilitet@kia.se</a>
                </p>
                <p>
                  Har du frågor kring daglig drift och användning? Kontakta oss
                  på <a href="mailto:info@kia.se">info@kia.se</a>
                </p>
                <p>
                  Behöver du akut hjälp och förarsupport? Till exempel om hyran
                  inte påbörjas Ring <a href="tel:0770-117000">0770-117000</a>
                </p>
              </div>
            </ContentTextBox>
          }
          secondComponent={
            <KIAImage
              src="https://www.kia.com/content/dam/kwcms/kme/se/sv/assets/campaigns/hyr-och-dela/RHD_EV6_GTL_MY25_LifstyleExterior_Side_with_Talent_CMYK-2.png"
              alt="KIA Car"
              sizes="(max-width: 768px) 100vw, 50vw"
              className="max-h-[450px] object-cover object-center"
            />
          }
          mobilFirstComponentOnTop={true}
          desktopFirstComponentFirst={false}
        />
        <FaqBlock
          className="bg-dark-blue"
          questions={[
            {
              q: 'Appen fungerar inte. Vad ska jag göra?',
              a: "Testa att starta om telefonen och appen. Dubbelkolla att du har bra mobiltäckning. Fungerar det fortfarande inte? Kontakta oss på <a href='tel:0770117000'>0770-11 70 00</a>.",
            },
            {
              q: 'Hur raderar jag mitt konto?',
              a: "Mejla oss på <a href='mailto:mobilitet@kia.se'>mobilitet@kia.se</a> så hjälper vi dig att radera din profil och all kunddata från plattformen.",
            },
            {
              q: 'Jag har laddat ned appen men det finns inga bilar att boka.',
              a: "Kia Drive är en bildelningstjänst för slutna grupper. För att kunna boka bilar behöver du vara del av en grupp. Är du inbjuden till Kia Drive kan du kontakta den som bjöd in dig för att få hjälp. Du kan också vända dig till <a href='mailto:mobilitet@kia.se'>mobilitet@kia.se</a>. Kom ihåg att berätta vilken grupp du tillhör, så att vi kan bjuda in dig på nytt. Du kommer då att få en kod som du anger under Inställningar i appen Kia Drive.",
            },
            {
              q: 'Hur ska jag påbörja min hyrperiod?',
              a: 'När startpunkten för din hyra närmar sig får du ett sms där det står vilket registreringsnummer din bil har. Bilen blir tillgänglig i appen tio minuter innan din angivna tidsbokning. När du kan börja använda bilen dyker den upp i appen under Mina resor.',
            },
            {
              q: 'Min bil dyker inte upp i appen trots att min bokning börjar.',
              a: "Kontakta förararsupport på nummer <a href='tel:0770117000'>0770-11 70 00</a>. De hjälper dig med hyror som inte startar eller behöver förlängas, samt andra akuta problem som kan uppstå inför och under hyrperioden.",
            },
            {
              q: 'Jag kan inte starta bilen.',
              a: 'Från det att du klickar på Lås upp & starta är bilen aktiv i två minuter. Under den tiden kan du starta bilen. Om du inte hinner starta bilen inom två minuter behöver du klicka på Lås upp & starta på nytt för att bilen ska starta.',
            },
            {
              q: 'Jag kan inte låsa eller låsa upp bilen.',
              a: 'Appen och bilen kommunicerar via mobildata och Bluetooth. Om signalerna är svaga eller om det finns störningar kan det ta upp till två minuter innan bilen svarar. Ring förararsupport om det inte funkar efter ett par försök.',
            },
            {
              q: 'Jag hittar inte bilen.',
              a: 'Klicka på stationen i appen så kan Google guida dig rätt. Om du redan är på rätt plats men inte hittar bilen, kontakta vår förararsupport.',
            },
            {
              q: 'Hur får jag upp tanklocket?',
              a: 'För att öppna tanklocket trycker du på en knapp som sitter till vänster om ratten. I laddhybrider kan det dröja en stund innan luckan öppnar sig eftersom bränsletanken behöver tryckregleras innan den går att öppna.',
            },
            {
              q: 'Hur laddar jag bilen?',
              a: "När bilen är olåst går det oftast att öppna laddluckan med ett lätt tryck. I vissa bilar finns även en knapp till vänster om ratten. Det finns några olika sorters laddningskontakter. Du kan inte göra fel om kabeln passar i bilen. Vid en privat laddare räcker det vanligtvis med att stoppa in kabeln i bilen för att laddningen ska starta. Vid publika laddare behöver du oftast starta laddningen via en app eller med en RFID-bricka. Vill du ha en smidig laddningsapp som fungerar hos nästan alla laddoperatörer i Europa? Kolla in <a href='https://www.kia.com/se/aga/support/kia-charge/'>Kia Charge</a>.",
            },
            {
              q: 'Laddsladden har fastnat i bilen.',
              a: 'Om laddsladden fastnar i bilen kan du testa att låsa upp bilen från låsknappen som finns inuti bilen. Knappen sitter oftast kring växelspaken eller på mittkonsolen. Laddar du på en publik laddstation ska du först avsluta laddningen på samma sätt som du påbörjade laddningen. Funkar det inte kan du trycka på nödstoppknappen som sitter på laddstationen och sedan försöka ta loss kabeln från bilen. Om du fortfarande inte kan koppla bort sladden kan du kontakta laddoperatören eller vår förarsupport.',
            },
            {
              q: 'Jag råkade starta bilen med laddkabeln i och nu vill den inte starta?',
              a: 'Stäng först av bilen genom att trycka på startknappen utan att ha foten på bromsen. Instrumentbelysningen ska då slockna. Lås sedan upp bilen med låsknappen som finns inne i bilen och dra sedan ur laddkabeln. Därefter ska bilen gå att starta som vanligt.',
            },
          ]}
          title="Vanliga frågor och svar"
        />
        <Snippet page="rent-support" />
      </div>
    </main>
  );
};
export default RentAndShareLanding;
